import React from 'react';
import Timeline from '@mui/lab/Timeline';
import { timelineItemClasses } from '@mui/lab/TimelineItem';
// import { Box } from '@mui/material';
// import ShortcutIcon from '@mui/icons-material/Shortcut';
import { createHistoryEventTree } from './helpers';
import HistoryTimelineItem from './HistoryTimelineItem';

interface HistoryTimelineProps {
  items: TranslationHistoryItem[]
}

const HistoryTimeline: React.FC<HistoryTimelineProps> = ({ items }) => {
  const groupedItems = createHistoryEventTree(items);

  if (!items?.length) {
    return null;
  }

  return (
    <Timeline
      sx={{
        p: 0,
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0,
        },
      }}
    >
      {groupedItems.map((historyItem, idx) => (
        <HistoryTimelineItem
          key={idx}
          lastEvent={historyItem.latestEventType}
          isPending={historyItem.isPending}
          events={historyItem.events}
          isConnected={historyItem.isConnected}
          isDeclined={historyItem.isDeclined}
          isDeactivated={historyItem.isDeactivated}
          reactivatedTranslation={historyItem.reactivatedTranslation}
        />
      ))}
    </Timeline>
  )
};

export default HistoryTimeline;
